import React, { useContext } from "react";
import AuthContext from "../../context/userAuth.context";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import Crop32Icon from "@mui/icons-material/Crop32";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import { AICreateCard } from "../../AIStudio/AIDashboardBits";
export const Create = () => {
  const history = useHistory();

  const { authenticationData, setAllProject, Role } = useContext(AuthContext);

  var Options = [
    {
      icon: <Crop32Icon sx={{ fontSize: 50 }}></Crop32Icon>,
      svg: (
        <svg
          className="dashSvgSize"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enableBackground="new 0 0 24 24"
          xml="preserve"
        >
          <g>
            <rect fill="none" width="24" height="24" />
          </g>
          <g>
            <g>
              <path
                fill="#286AFF"
                d="M22.6,10.5V6c0-1.1-0.7-2-2.3-2H3.6C2.1,4,1.4,4.9,1.4,6v12c0,1.1,0.7,2,2.3,2h16.7c1.5,0,2.3-0.9,2.3-2
                    v-4.5V10.5z M20.4,18H3.6V6h16.7V18z"
              />
            </g>
          </g>
          <text
            transform="matrix(1 0 0 1 6.2099 14.323)"
            fill="#286AFF"
            fontFamily="Circular-Loom"
            fontSize="6px"
          >
            16:9
          </text>
        </svg>
      ),
      Heading: "Horizontal",
      Subheading: "Great for presentations, <br />videos and web ",
    },
    {
      icon: <CropSquareIcon sx={{ fontSize: 50 }}></CropSquareIcon>,
      svg: (
        <svg
          className="dashSvgSize"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enableBackground="new 0 0 24 24"
          xml="preserve"
        >
          <g>
            <rect fill="none" width="24" height="24" />
          </g>
          <g>
            <g>
              <path
                fill="#286AFF"
                d="M20,10.5V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-4.5V10.5z M18,18H6
              V6h12V18z"
              />
            </g>
          </g>
          <text
            transform="matrix(1 0 0 1 8.7724 14.323)"
            fill="#286AFF"
            fontFamily="Circular-Loom"
            fontSize="6px"
          >
            1:1
          </text>
        </svg>
      ),

      Heading: "Square",
      Subheading: "Ideal for posts on Facebook<br /> and Instagram",
    },
    {
      icon: <CropPortraitIcon sx={{ fontSize: 50 }}></CropPortraitIcon>,
      svg: (
        <svg
          className="dashSvgSize"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enableBackground="new 0 0 24 24"
          xml="preserve"
        >
          <g>
            <rect x="0" fill="none" width="24" height="24" />
          </g>
          <g>
            <g>
              <path
                fill="#286AFF"
                d="M10.5,1.4H6c-1.1,0-2,0.7-2,2.3v16.7c0,1.5,0.9,2.3,2,2.3h12c1.1,0,2-0.7,2-2.3V3.6c0-1.5-0.9-2.3-2-2.3
                    h-4.5H10.5z M18,3.6v16.7H6V3.6H18z"
              />
            </g>
          </g>
          <text
            transform="matrix(1 0 0 1 6.2099 14.323)"
            fill="#286AFF"
            fontFamily="Circular-Loom"
            fontSize="6px"
          >
            9:16
          </text>
        </svg>
      ),
      Heading: "Vertical",
      Subheading: "Perfect for social Media<br /> and mobile usage.",
    },
    {
      icon: <Crop32Icon fontSize="large"></Crop32Icon>,
      svg: (
        <svg
          className="dashSvgSize"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          enableBackground="new 0 0 24 24"
          xml="preserve"
        >
          <g>
            <rect fill="none" width="24" height="24" />
          </g>
          <g>
            <g>
              <path
                fill="#286AFF"
                d="M18,10.5V6c0-1.1-0.9-2-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-4.5l4,4v-11L18,10.5z M16,9.7V18H4V6h12V9.7z"
              />
              <circle fill="#286AFF" cx="10" cy="10" r="2" />
              <path
                fill="#286AFF"
                d="M14,15.4c0-0.8-0.5-1.5-1.2-1.9C11.9,13.2,11,13,10,13s-1.9,0.2-2.8,0.6c-0.7,0.3-1.2,1-1.2,1.9V16h8V15.4z"
              />
            </g>
          </g>
        </svg>
      ),
      Heading: "Capture",
      Subheading: "Why waste time in meetings?<br /> Record it, send it, done.",
    },
  ];

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const CreateProject = (params) => {
    sessionStorage.removeItem("createNewProject");
    sessionStorage.removeItem("myProjectData");
    sessionStorage.removeItem("CurrentChooseProjectId");
    sessionStorage.setItem("createNewProject", "newProject");
    if (Role == "admin") {
      let str;
      if (params === "Horizontal") {
        str = "16:9";
      } else if (params === "Square") {
        str = "1:1";
      } else if (params === "Vertical") {
        str = "9:16";
      }
      sessionStorage.setItem("ProjectAspectRatio", str);
      history.push("./editor");

      // fetch(authenticationData.ApiBaseURL + "/api/Template/CreateTemplateData?body=" + str, {
      //     method: 'POST',
      //     headers: {
      //         "Content-Type": "application/json",
      //         "Access-Control-Allow-Origin": "*",
      //         Authorization: "Bearer " + authData.access_token,
      //     },
      // }).then(response => response.json()).then(data => {
      //     if (data != null) {
      //         if (data.result) {
      //             setAllProject(data.result)
      //         } else {
      //             setAllProject([])
      //         }
      //         localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
      //         history.push('./editor')
      //     }
      // }).catch(error => {

      // });
    } else {
      let str;
      if (params === "Horizontal") {
        str = "16:9";
      } else if (params === "Square") {
        str = "1:1";
      } else if (params === "Vertical") {
        str = "9:16";
      }
      sessionStorage.setItem("ProjectAspectRatio", str);
      history.push("./editor");
      // fetch(authenticationData.ApiBaseURL + "/api/Project/StartProject?body=" + str, {
      //     method: 'POST',
      //     headers: {
      //         "Content-Type": "application/json",
      //         "Access-Control-Allow-Origin": "*",
      //         Authorization: "Bearer " + authData.access_token,
      //     },
      // }).then(response => response.json()).then(data => {
      //     if (data != null) {
      //         setAllProject(data.result)
      //         localStorage.setItem('CurrentChooseProject', JSON.stringify(data.currentItem));
      //         history.push('./editor')
      //     }
      // }).catch(error => {

      // });
    }
  };

  return (
    <>
      <h4>Design. Create. Share.</h4>
      <AICreateCard />
      <div className="mt-3 createUpper">
        {Options.map((value, index) => {
          return (
            <React.Fragment key={index}>
              {value.Heading != "Capture" && (
                <div
                  key={value.Heading + index}
                  className="createMiddle svgcolor"
                  onClick={() => CreateProject(value.Heading)}
                >
                  <div className="Icon_Center">
                    <span className="dashIconColor">{value.icon}</span>
                    <h4 className="dashTextColor"> {value.Heading}</h4>
                  </div>
                  <p
                    className="dashSubTextColor"
                    dangerouslySetInnerHTML={{ __html: value.Subheading }}
                  ></p>
                </div>
              )}
              {/* {value.Heading == 'Capture' && <div key={value.Heading + index} style={{ position: 'relative' }} className="createMiddle svgcolor" onClick={() => {
                        Swal.fire("Comming Soon", "This feature will be live soon.", "info");
                    }}>
                        <div className="Icon_Center">
                            <span className="dashIconColor"> {value.svg} </span>
                            <h4 className="dashTextColor"> {value.Heading}</h4>
                        </div>
                        <p className="dashSubTextColor" dangerouslySetInnerHTML={{ __html: value.Subheading }}></p>
                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            top: '0px',
                            left: '0px',
                            height: '100%',
                            background: '#7c7979',
                            opacity: '0.6',
                            borderRadius: '15px'
                        }} >
                            <span className="material-icons" style={{
                                fontSize: '30px',
                                position: 'absolute',
                                right: '13px',
                                top: '10px'
                            }}> lock </span>
                        </div>
                    </div>} */}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};
export default Create;
